/**
 * DTO for pending rewards totals
 * Used for tracking rakeback and weekly rake share rewards pending distribution
 *
 * @param pendingRakebackTotalUsdt - Total pending rakeback amount in USDT
 * @param pendingRakebackTotalPhnm - Total pending rakeback amount in PHNM (string representation for precision)
 * @param pendingWeeklyRakeShareTotalUsdt - Total pending weekly rake share amount in USDT
 * @param pendingWeeklyRakeShareTotalPhnm - Total pending weekly rake share amount in PHNM (string representation for precision)
 * @param totalUsdtAmount - Combined total USDT amount (rakeback + weekly rake share)
 * @param totalPhnmNeeded - Combined total PHNM needed (string representation for precision)
 * @param totalPhnmNeededWei - Combined total PHNM needed in Wei (BigInt for blockchain precision)
 * @param weekStartDate - The start date of the week for which these pending rewards are calculated
 * @param rewardPayoutCount - DEPRECATED: Always 0 as reward_payouts are no longer used
 * @param rakebackPayoutCount - Number of rakeback payouts pending
 * @param weeklyRakeSharePayoutCount - Number of weekly rake share payouts pending
 * @param totalRewardsPhnm - DEPRECATED: Always 0 as reward_payouts are no longer used
 */
export interface PendingRewardTotalsDto {
  pendingRakebackTotalUsdt: number;
  pendingRakebackTotalPhnm: string;
  pendingWeeklyRakeShareTotalUsdt: number;
  pendingWeeklyRakeShareTotalPhnm: string;
  totalUsdtAmount: number;
  totalPhnmNeeded: string;
  totalPhnmNeededWei: bigint;
  weekStartDate: Date;
  rewardPayoutCount: number;
  rakebackPayoutCount: number;
  weeklyRakeSharePayoutCount: number;
  totalRewardsPhnm: number;
}
